export default __webpack_public_path__ + "static/media/grandmAndLady4.59064be8.jpg";